import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { HeyatYoluContext } from "../../App";
import { FaDollarSign, FaSave, FaLock, FaToggleOn, FaToggleOff } from "react-icons/fa";

function SettingsDashboard() {
  const { user } = useContext(HeyatYoluContext);
  const [amount, setAmount] = useState("");
  const [isPaymentActive, setIsPaymentActive] = useState(true); // ← YENİ
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toggling, setToggling] = useState(false);           // ← YENİ
  const [showToggleConfirm, setShowToggleConfirm] = useState(false); // ← YENİ

  // ← DƏYİŞDİ: current-amount əvəzinə admin/payment-settings (məbləğ + rejim birlikdə)
  useEffect(() => {
    api.get("/admin/payment-settings")
      .then(res => {
        setAmount(res.data.amount);
        setIsPaymentActive(res.data.isPaymentActive);
        setLoading(false);
      })
      .catch(err => {
        toast.error("Ödəniş parametrlərini yükləmək mümkün olmadı.");
        setLoading(false);
      });
  }, []);

  const handleUpdate = async () => {
    try {
      const parsed = parseFloat(amount);
      if (isNaN(parsed) || parsed <= 0) {
        return toast.error("Doğru məbləğ daxil edin.");
      }

      setSaving(true);
      await api.put("/admin/update-amount", { newAmount: parsed });
      toast.success("Məbləğ uğurla yeniləndi!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Xəta baş verdi.");
    } finally {
      setSaving(false);
    }
  };

  // ← YENİ: Ödəniş rejimini dəyiş
  const handleTogglePayment = async () => {
    setShowToggleConfirm(false);
    setToggling(true);

    try {
      const res = await api.patch("/admin/toggle-payment", {
        isPaymentActive: !isPaymentActive,
      });

      setIsPaymentActive(res.data.isPaymentActive);

      toast.success(
        res.data.isPaymentActive
          ? `💳 Ödənişli rejim aktivləşdirildi (${Number(res.data.amount).toFixed(2)} AZN)`
          : "🆓 Ödənişsiz rejim aktivləşdirildi — yeni profillər admin təsdiqi ilə yayımlanacaq"
      );
    } catch (error) {
      toast.error(error.response?.data?.message || "Rejim dəyişdirilə bilmədi.");
    } finally {
      setToggling(false);
    }
  };

  if (loading) {
    return (
      <div className="hy-settings-loading">
        <div className="hy-settings-spinner" />
        <p>Yüklənir...</p>
      </div>
    );
  }

  const isAdmin = user?.role === "admin";

  return (
    <div className="hy-settings-container">
      <div className="hy-settings-header">
        <h2 className="hy-settings-title">
          <FaDollarSign /> Ödəniş Parametrləri
        </h2>
        <p className="hy-settings-subtitle">Memorial profil üçün ödəniş məbləğini və rejimini idarə edin</p>
      </div>

      <div className="hy-settings-card">
        {!isAdmin && (
          <div className="hy-settings-access-warning">
            <FaLock className="hy-settings-warning-icon" />
            <div>
              <h4>Məhdud İcazə</h4>
              <p>Yalnız adminlər bu parametrləri dəyişə bilər</p>
            </div>
          </div>
        )}

        <div className="hy-settings-form">
          {/* ═══════════ YENİ: Ödəniş Rejimi bölməsi ═══════════ */}
          <div className="hy-settings-input-group">
            <label className="hy-settings-label">
              Ödəniş Rejimi
            </label>

            <div className={`hy-settings-mode-box ${isPaymentActive ? "hy-mode-paid" : "hy-mode-free"}`}>
              <div className="hy-settings-mode-info">
                <span className={`hy-settings-mode-badge ${isPaymentActive ? "hy-badge-paid" : "hy-badge-free"}`}>
                  {isPaymentActive ? "💳 ÖDƏNİŞLİ" : "🆓 ÖDƏNİŞSİZ"}
                </span>
                <p className="hy-settings-mode-text">
                  {isPaymentActive
                    ? "Yeni profillər üçün ödəniş tələb olunur. Ödənişdən sonra profil avtomatik yayımlanır."
                    : "Yeni profillər pulsuz yaradılır və admin təsdiqindən sonra yayımlanır."}
                </p>
              </div>

              {isAdmin && !showToggleConfirm && (
                <button
                  type="button"
                  onClick={() => setShowToggleConfirm(true)}
                  disabled={toggling}
                  className={`hy-settings-toggle-btn ${isPaymentActive ? "hy-toggle-to-free" : "hy-toggle-to-paid"}`}
                >
                  {isPaymentActive ? <FaToggleOff /> : <FaToggleOn />}
                  {isPaymentActive ? "Ödənişsiz rejimə keç" : "Ödənişli rejimə keç"}
                </button>
              )}

              {isAdmin && showToggleConfirm && (
                <div className="hy-settings-confirm-box">
                  <p>
                    <strong>Əminsiniz?</strong>{" "}
                    {isPaymentActive
                      ? "Yeni profillər pulsuz yaradılacaq (admin təsdiqi ilə)."
                      : `Yeni profillər üçün ${Number(amount).toFixed(2)} AZN ödəniş tələb olunacaq.`}
                  </p>
                  <div className="hy-settings-confirm-actions">
                    <button
                      type="button"
                      onClick={handleTogglePayment}
                      disabled={toggling}
                      className="hy-settings-confirm-yes"
                    >
                      {toggling ? "Dəyişdirilir..." : "✅ Bəli, dəyiş"}
                    </button>
                    <button
                      type="button"
                      onClick={() => setShowToggleConfirm(false)}
                      disabled={toggling}
                      className="hy-settings-confirm-no"
                    >
                      ❌ İmtina
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ═══════════ Mövcud: Məbləğ bölməsi ═══════════ */}
          <div className="hy-settings-input-group">
            <label className="hy-settings-label">
              Cari Məbləğ (AZN)
              {isAdmin && <span className="hy-settings-required">*</span>}
            </label>
            <div className="hy-settings-input-wrapper">
              <span className="hy-settings-currency-icon">₼</span>
              <input
                type="number"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                step="0.01"
                min="0"
                disabled={!isAdmin}
                className="hy-settings-input"
                placeholder="0.00"
              />
            </div>
            {isAdmin && (
              <p className="hy-settings-hint">
                Bu məbləğ memorial profil yaratmaq üçün tələb olunacaq
                {!isPaymentActive && " (hazırda ödənişsiz rejim aktivdir — məbləğ yalnız ödənişli rejimə qayıdanda istifadə olunacaq)"}
              </p>
            )}
          </div>

          {isAdmin && (
            <button
              onClick={handleUpdate}
              disabled={saving}
              className="hy-settings-save-btn"
            >
              {saving ? (
                <>
                  <div className="hy-settings-btn-spinner" />
                  Yadda saxlanılır...
                </>
              ) : (
                <>
                  <FaSave />
                  Yadda Saxla
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SettingsDashboard;